export var SampleMode;
(function (SampleMode) {
    SampleMode[SampleMode["Period"] = 0] = "Period";
    SampleMode[SampleMode["OnChange"] = 1] = "OnChange";
})(SampleMode || (SampleMode = {}));
